<script lang="ts">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { getStr } from '../../../../../common/util';
  import Icon from '../../../../common/components/Icon.svelte';

  export let variant;
  export let place = 'expire-drop-down';

  const { joodExpiredFlag, extraThemeResourcePath, encodedContextPath } = getAppConfig();
  $: joodExpiredLabel = getJoodExpiredLabel(variant, joodExpiredFlag);
  const joodSubscribeLinkHref = `${encodedContextPath}/jood/benefits`;

  // Utility Functions
  function getJoodExpiredLabel(variant, joodExpiredFlag) {
    const joodTypeArray = {
      BASIC: 'blue',
      VIP: 'gold',
      SMART: 'smart',
    };

    const variants = { pdp: 'pdp', 'plp-list': 'plp', qac: 'addtocart' };
    const suffix = variants[variant] || 'all';
    return getStr(`extra.jood.wallet.jood.renew.link.${joodTypeArray[joodExpiredFlag]}.${suffix}`);
  }
</script>

{#if joodExpiredFlag}
  <div class="subscribe-upgrade-bottom">
    <div class="c_expirecard pdp-card {place}">
      <div class="c_infoicon">
        <img
          src="{extraThemeResourcePath}/images/jood/expired/info-icon.svg"
          class="joodInfoIcon checkoutPriceCard"
          alt="Jood"
        />
      </div>
      <div class="expired-text-container expired-text-{joodExpiredFlag}">
        <a href={joodSubscribeLinkHref} on:click|stopPropagation>
          <span class="expired-text">{getStr('extra.jood.expired')}</span>
          <button class="renewal-link"
            >{joodExpiredLabel} <Icon type="font" glyph="chevron_right" mobileSize={12} /></button
          >
        </a>
      </div>
    </div>
  </div>
{/if}
